import { useGetProfileQuery } from '../Redux/Apis/authApi'
import Loading from '../Components/Shared/Loading'
import { Navigate, useLocation } from 'react-router'

const AdminRoutes = ({ children }) => {
    const location = useLocation()
    // The httpOnly cookie is sent automatically; auth state is derived purely
    // from whether the profile call succeeds (no JS-readable token to gate on).
    const { data, isLoading, isError, isFetching } = useGetProfileQuery()

    if (isLoading || isFetching) return <Loading />
    if (isError || data?.data?.role !== 'ADMIN') {
        return <Navigate to="/login" state={location.pathname} />
    }

    return children
}

export default AdminRoutes
